import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface PmGlobalSearchRequestApi {
  parentUserId: number;
  actingUserId: number;
  searchName: string;
  take?: number;
}

export interface PmGlobalSearchItemApi {
  moduleType: string;
  id: string;
  name: string;
  clientUniversalId?: string | null;
  clientName?: string | null;
  createdOn?: string | null;
  dueDate?: string | null;
  /** Pages & features only (matched in the browser, not returned by the API): the line under the title. */
  hint?: string | null;
}

export interface PmGlobalSearchResponseApi {
  query: string;
  totalCount: number;
  items: PmGlobalSearchItemApi[];
}

@Injectable({ providedIn: 'root' })
export class PmGlobalSearchApiService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.pmApiBaseUrl;

  search(payload: PmGlobalSearchRequestApi): Observable<PmGlobalSearchResponseApi> {
    return this.http.post<PmGlobalSearchResponseApi>(`${this.base}/api/v1/search/global`, payload);
  }
}
